import React from 'react';
import MemberList from './members/MemberList';
import ProjectList from './projects/ProjectList';

const Sidebar = () => {
    return (
        <div className="sidebar">
      <ProjectList />     
      <MemberList />
    </div>
    );
};

export default Sidebar;